import React from "react";

import { useLocation } from "react-router-dom";

import ServerGroupPerDatabaseQueryPerformance from "components/ServerGroupPerDatabaseQueryPerformance";
import ServerGroupQueryPerformance from "components/ServerGroupQueryPerformance";

function ServerGroupQueryOverview() {
  const { search } = useLocation();
  const dbParam = new URLSearchParams(search).get("datname");

  if (dbParam) {
    return <ServerGroupPerDatabaseQueryPerformance datname={dbParam} />;
  }

  return <ServerGroupQueryPerformance />;
}

export default ServerGroupQueryOverview;
